import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { FileUpload } from '@shared/models';

@Directive({
  selector: '[appOfflineLogo]',
})
export class OfflineLogoDirective implements OnChanges {
  @Input() fileUpload: FileUpload;
  @Input() base64EncodedLogoContent: string;

  constructor(private element: ElementRef) {}

  ngOnChanges(): void {
    if (this.element.nativeElement.tagName !== 'IMG') {
      return;
    }

    if (!this.base64EncodedLogoContent) {
      this.element.nativeElement.style.display = 'none';
      return;
    }

    const imageType = this.fileUpload ? this.fileUpload.type : 'image/svg+xml';
    const imageData = this.base64EncodedLogoContent;

    if (this.element.nativeElement.classList.contains('d-none')) {
      this.element.nativeElement.classList.remove('d-none');
    }

    this.element.nativeElement.style.display = 'inline-block';
    this.element.nativeElement.setAttribute(
      'src',
      'data:' + imageType + ';base64,' + imageData
    );
  }
}
